/**
 * Company scoping helpers for list pages (invoices, purchase bills).
 * Resolves which company a record belongs to, tolerating legacy/imported
 * records whose companyId is blank or stale by falling back to name matching.
 */

export const ALL_COMPANIES = "ALL";
export const UNASSIGNED_COMPANY = "__unassigned__";

const normalizeName = (value) => String(value || "").trim().toLowerCase();

export function getRecordCompanyKey(record, companies = []) {
  if (!record) return UNASSIGNED_COMPANY;

  if (record.companyId && companies.some((c) => c.id === record.companyId)) {
    return record.companyId;
  }

  const candidateNames = [
    record.companyName,
    record.companyDetails?.name,
    record.sellerConfig?.name
  ].map(normalizeName).filter(Boolean);

  const matched = companies.find((c) => candidateNames.includes(normalizeName(c.name)));
  return matched ? matched.id : UNASSIGNED_COMPANY;
}
